import { InjectionToken, Type } from '@angular/core';
import { RcV2MembershipFailedDialogComponent } from '@features/redeem-cash-v2/components/membership-failed-dialog/membership-failed-dialog.component';
import { RcV2CheckoutLinkAccountDialogComponent } from '@features/redeem-cash-v2/containers/checkout-link-account-dialog/checkout-link-account-dialog.component';

export const RCV2_CHECKOUT_LINK_ACCOUNT_DIALOG = new InjectionToken<Type<any>>(
  'RCV2_CHECKOUT_LINK_ACCOUNT_DIALOG',
  {
    factory: () => RcV2CheckoutLinkAccountDialogComponent,
  },
);

export const RCV2_MEMBERSHIP_FAILED_DIALOG = new InjectionToken<Type<any>>(
  'RCV2_MEMBERSHIP_FAILED_DIALOG',
  {
    factory: () => RcV2MembershipFailedDialogComponent,
  },
);
